<template>
  <button
    class="dataset-tag-row"
    type="button"
    aria-label="Manage Tags and Versions"
    @click="openHistoryPage"
  >
    <template v-if="hasTag">
      <span class="dataset-tag-row__label">Tag:</span>
      <span v-tooltip:center.top="'Manage Tags and Versions'" class="dataset-tag-row__tag">{{ tad }} <span v-if="props.tag_state === 'dirty'" class="dataset-tag-row__state">({{ tagStateLabel }})</span></span>
      <span class="dataset-tag-row__description">{{ tag_description }}</span>
    </template>
    <template v-else>
      <span v-tooltip:center.top="'Manage Tags and Versions'" class="dataset-tag-row__warning">
        Tag does not exist
      </span>
    </template>
  </button>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const props = defineProps({
  tad: {
    type: String,
    default: '',
  },
  tag_description: {
    type: String,
    default: '',
  },
  dataset_id: {
    type: [String, Number],
    default: '',
  },
  tag_state: {
    type: String,
    default: 'dirty',
  },
});

const router = useRouter();
const route = useRoute();

const hasTag = computed(() => Boolean((props.tad || '').trim()));

const getTagStateLabel = (state) => {
  const stateMap = {
    tagged: 'Tagged',
    clean: 'Clean',
    dirty: 'Dirty'
  };
  return stateMap[state] || (state ? String(state) : 'Unknown');
};

const tagStateLabel = computed(() => getTagStateLabel(props.tag_state));

function openHistoryPage() {
  const datasetId = props.dataset_id || route.params.id || route.params.datasetId;

  if (datasetId) {
    router.push({ name: 'dataset.history', params: { id: datasetId } });
    return;
  }

  router.push({ name: 'datasets' });
}
</script>

<style scoped lang="scss">
.dataset-tag-row {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  font-size: 0.75rem;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
  text-align: left;

  &:hover {
    opacity: 0.8;
  }

  &__label {
    font-weight: 400;
    @include themify() {
      color: themed('body-text-color-secondary');
    }
  }

  &__tag {
    font-weight: 400;
    @include themify() {
      color: themed('body-text-color');
    }
  }

  &__state {
    font-size: 1em;
    font-weight: 700;
    color: #1976d2;
    margin-left: 2px;
    font-family: 'Roboto', Arial, sans-serif;
  }

  &__description {
    @include themify() {
      color: themed('body-text-color-secondary');
    }
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__warning {
    color: #d32f2f;
    font-weight: 700;
    font-size: 1em;
    cursor: pointer;
    font-family: 'Roboto', Arial, sans-serif;
  }
}
</style>
